import{d as t}from"./chunk-VP57L3S5.js";import{b as o}from"./chunk-RSCRYFTW.js";import{m as e}from"./chunk-HBP5N4FR.js";e();var v=()=>{let r=t(),c=o(r);return{provider:r,providerType:c}};export{v as a};
//# sourceMappingURL=chunk-ZQ623UIW.js.map
